import React, { Children, Fragment, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";

import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { ReactComponent as UploadIcon } from "../../assets/icons/upload.svg";
import { ReactComponent as CameraIcon } from "../../assets/icons/camera.svg";
import { ReactComponent as CalibrateIcon } from "../../assets/icons/calibrate.svg";
import { ReactComponent as CircleIcon } from "../../assets/icons/circle_empty.svg";
import { ReactComponent as SquareIcon } from "../../assets/icons/square.svg";
import { ReactComponent as GestureIcon } from "../../assets/icons/gesture.svg";
import { ReactComponent as ZoomInIcon } from "../../assets/icons/zoom_in.svg";
import { ReactComponent as ZoomOutIcon } from "../../assets/icons/zoom_out.svg";
import { ReactComponent as PenIcon } from "../../assets/icons/pen_tool.svg";
import { ReactComponent as FormatIcon } from "../../assets/icons/format.svg";
import { ReactComponent as CropFreeIcon } from "../../assets/icons/crop_free.svg";
import { ReactComponent as PhotoIcon } from "../../assets/icons/photo.svg";

import UploadImage from "../Upload/UploadImage";
import Modal from "./Modal";
import ActionButton from "../Buttons/ActionButton";
import PrimaryButton from "../Buttons/PrimaryButton";
import OutlinedButton from "../Buttons/OutlinedButton";
import Select from "../DataEntry/Select";
import { useDataset, useDevice, useDevices } from "../../Api/newSockets.api";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

type Props = {
  setWizardState?: any;
  loadingScreen?: boolean;
  groupId?: string;
  groupName?: string;
  title?: string;
  description?: string;
  datasetId?: any;
  onSave: any;
};

const AddImagesWizard = (props: Props) => {
  console.log("props.loadingScreen", props.loadingScreen);
  const screens = [
    {
      order: 0,
      title: "Select your method",
    },
    {
      order: 1,
      title: "Upload image from your local computer",
    },
    {
      order: 2,
      title: "Take an image from your device",
    },
  ];

  const [currentScreen, setCurrentScreen] = useState(screens[0]);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [nextPage, setNextPage] = useState();
  const [disable, setDisable] = useState(true);
  const [streamUrl, setStreamUrl] = useState();
  const [cameraDeviceId, setCameraDeviceId] = useState();
  const [loading, setLoading] = useState(false);
  const { getDevicesByDeviceType } = useDevices();
  const { getDevice } = useDevice();
  const { cameraCapture } = useDevice();
  //TO DO fetch devicetypes and their ids
  const cameraDevices = getDevicesByDeviceType(9);

  const closeWizard = (e: React.MouseEvent<HTMLElement>) => {
    props.setWizardState(false);
  };

  const handleNextPage = (e) => {
    setDisable(false);
    console.log(e.target.value);
  };
  const handleScenarioA = (e: React.MouseEvent<HTMLElement>) => {
    // setDisable(false);
    setCurrentScreen(screens[currentScreen.order + 1]);
    e.stopPropagation();
  };

  const handleScenarioB = (e: React.MouseEvent<HTMLElement>) => {
    // setDisable(false);
    setCurrentScreen(screens[currentScreen.order + 2]);
    e.stopPropagation();
  };

  const handleBackButton = () => {
    setCurrentScreen(screens[0]);
  };

  const handleSubmit = () => {
    setLoading(true);
    props.onSave && props.onSave(uploadedImages);
  };

  const handleCameraChange = (deviceId) => {
    setCameraDeviceId(deviceId);
    const camera: any = getDevice(deviceId);
    const hostingDevice: any = getDevice(camera?.device.connectedTo);
    setStreamUrl(hostingDevice.device?.settings?.cameraStreamEndpoint);
  };

  const handleCapture = async () => {
    var dataset = await cameraCapture(cameraDeviceId, props.datasetId);
  };

  var footer = (
    <>
      <PrimaryButton onSubmit={handleCapture}>Capture</PrimaryButton>
      <OutlinedButton onClick={handleBackButton}>Back</OutlinedButton>
    </>
  );

  const removeImageFromArray = (image) => {
    const newImages = uploadedImages.filter((img) => img != image);
    setUploadedImages(newImages);
  };

  return (
    <>
      {/* New Modals */}
      {currentScreen.order == 0 ? (
        <Modal
          title="Select your method"
          visible={disable}
          onClose={closeWizard}
        >
          <div className="wizard-body">
            <div className="wizard-row">
              <div className="left-container">
                <button className="left" onClick={handleScenarioA}>
                  <UploadIcon
                    style={{ fill: "#aeb3bd", height: "36px", width: "36px" }}
                  />
                  <p>Upload images from your computer.</p>
                </button>
              </div>
              <div className="right-container" onClick={handleScenarioB}>
                <button className="right">
                  <CameraIcon
                    style={{ fill: "#aeb3bd", height: "36px", width: "36px" }}
                  />
                  <p>Take an image from your device.</p>
                </button>
              </div>
            </div>
          </div>
        </Modal>
      ) : (
        ""
      )}
      {currentScreen.order == 1 && (
        <Fragment>
          <Modal
            title="Upload your image"
            visible={true}
            buttonBack={true}
            onSubmit={handleSubmit}
            onBack={handleBackButton}
            onClose={closeWizard}
            submitLoading={loading}
          >
            {props.loadingScreen ? (
              <LoadingSpinner loadingText="Uploading..." />
            ) : (
              <UploadImage
                datasetId={props.datasetId}
                uploadImages={setUploadedImages}
                uploadedImages={uploadedImages}
                removeImage={removeImageFromArray}
              />
            )}
          </Modal>
        </Fragment>
      )}
      {currentScreen.order == 2 && (
        <Modal
          title="Take an image with your device"
          visible={true}
          onClose={closeWizard}
          largeContent="Large"
          footer={footer}
        >
          <div className="form">
            <Select
              placeholder="Select camera device"
              onChange={(e: any) => handleCameraChange(e.target.value)}
              options={cameraDevices.devices}
            />
          </div>
          <div className="capture-image-container">
            <div className="capture-image-content">
              <div className="capture-image">
                <img
                  style={{ width: "100%", height: "100%" }}
                  src={streamUrl}
                />
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default AddImagesWizard;
